import { render, staticRenderFns } from "./Correlations.vue?vue&type=template&id=9e36f04a&scoped=true&"
import script from "./Correlations.vue?vue&type=script&lang=js&"
export * from "./Correlations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e36f04a",
  null
  
)

export default component.exports